import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    id: "ip-group-001",
    name: "IP Group 001",
    ipList: [
      {
        ipAddress: "192.168.1.10",
        subnet: "32",
        description: "Office Printer",
      },
      {
        ipAddress: "192.168.1.11",
        subnet: "32",
        description: "Conference Room Display",
      },
      {
        ipAddress: "192.168.1.12",
        subnet: "32",
        description: "Security Camera",
      },
    ],
  },
  {
    id: "ip-group-002",
    name: "IP Group 002",
    ipList: [
      {
        ipAddress: "10.10.20.21",
        subnet: "32",
        description: "Guest Tablet",
      },
      {
        ipAddress: "10.10.20.22",
        subnet: "32",
        description: "Guest Phone",
      },
    ],
  },
  {
    id: "ip-group-003",
    name: "Lab Devices",
    ipList: [
      ...Array.from({ length: 24 }, (_, i) => ({
        ipAddress: `172.16.10.${i + 1}`,
        subnet: "32",
        description: `Lab Device ${i + 1}`,
      })),
    ],
  },
];

const initialState = {
  resource: "ipAddress",
  data: [...fakeData],
};

export const profileIpAddressSlice = createSlice({
  name: "profileIpAddress",
  initialState,
  reducers: {
    setIpAddressesData: (state, _) => {
      state.data = [...fakeData];
    },
    createIpAddressProfile: (state, action) => {
      const newIpAddresses = {
        id: `ip-group-${(state.data.length + 1).toString().padStart(3, "0")}`,
        name: action.payload.name,
        ipList: action.payload.ipList,
      };

      fakeData = [...fakeData, newIpAddresses];
      state.data.push(newIpAddresses);
    },
    updateIpAddressProfile: (state, action) => {
      const index = state.data.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...action.payload,
        };
        state.data[index] = {
          ...state.data[index],
          ...action.payload,
        };
      }
    },
    deleteIpAddressProfile: (state, action) => {
      state.data = state.data.filter(item => !action.payload.profileIpAddrsIds.includes(item.id));
      fakeData = fakeData.filter(item => !action.payload.profileIpAddrsIds.includes(item.id));
    },
  },
});

export const {
  setIpAddressesData,
  createIpAddressProfile,
  updateIpAddressProfile,
  deleteIpAddressProfile,
} = profileIpAddressSlice.actions;

export default profileIpAddressSlice.reducer;
